import Axios from "axios"

export default class GridCompetenciesClient {

    constructor(endpoint) {
        this.endpoint = endpoint
    }

    create(data) {
        return axios.post(this.endpoint+'/'+data.competency_id, data)
    }

    update(data) {
        return axios.post(this.endpoint+'/'+data.competency_id, data)
    }

    delete(id) {
        return axios.delete(this.endpoint+'/'+id)
    }
}